.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.titleWithIcon {
  display: flex;
  align-items: center;
  column-gap: var(--spacingLg);
  max-width: 100%;
}
